'use client';

import dynamic from 'next/dynamic';
import BoxLink from './box-link';
import ContactDetails from './contact-details';
import ContactUsForm from './contact-us-form';
import FollowUpOrder from './follow-up-order';
import HolidayCalendar from './holiday-calendar';
import MapSkeleton from './map-skeleton';
import { LINKS } from '../constants';
const AddressMap = dynamic(() => import('@/app/contact-us/_components/office-location'), {
  ssr: false,
  loading: () => <MapSkeleton />
});
function ContactUsContent() {
  return <div className='grid grid-cols-12 md:gap-x-6 md:gap-y-10' data-sentry-component="ContactUsContent" data-sentry-source-file="contact-us-content.tsx">
            <ContactDetails data-sentry-element="ContactDetails" data-sentry-source-file="contact-us-content.tsx" />

            <AddressMap data-sentry-element="AddressMap" data-sentry-source-file="contact-us-content.tsx" />
            <FollowUpOrder showDevice='mobile' data-sentry-element="FollowUpOrder" data-sentry-source-file="contact-us-content.tsx" />

            <div className='col-span-full mb-8 flex flex-col gap-6 md:mb-0 md:flex-row md:gap-10'>
                {LINKS.map(item => {
        return <BoxLink key={item.title} link={item.link} title={item.title} />;
      })}
            </div>
            <ContactUsForm data-sentry-element="ContactUsForm" data-sentry-source-file="contact-us-content.tsx" />
            <HolidayCalendar data-sentry-element="HolidayCalendar" data-sentry-source-file="contact-us-content.tsx" />
        </div>;
}
export default ContactUsContent;